import axios from "axios";

export const API = axios.create({
  baseURL: "https://examwebsiteapi.nuhvin.com",
});

export const APIURL = "https://examwebsiteapi.nuhvin.com";

// export const API = axios.create({
//   baseURL: "http://192.168.1.126:5004",
// });

// export const APIURL = "http://192.168.1.126:5004";
